import { Loader, Tabs } from '@mantine/core';
// components
import { Terminal, FileText } from 'lucide-react';
import { IAct } from '@newo/api/gateway';
import Runtime from '@/modules/ActLogDrawer/components/Runtime';
import Prompts from '@/modules/ActLogDrawer/components/Prompts';
import NoRecords from '@/components/NoRecords';
// icons
// utils
import { useLogsQuery } from '@/services/analytics/analytics.queries.ts';

interface MessageDetailsProps {
    act: IAct;
}

const MessageDetails = ({ act }: MessageDetailsProps) => {
    const { data, isSuccess, isLoading } = useLogsQuery({
        per: 200,
        runtime_context_id: act.runtime_context_id ?? undefined,
        log_types: ['call'],
        message: 'gen'
    });

    const logs = data?.items ?? [];

    if (isLoading) {
        return (
            <div className="flex justify-center py-20">
                <Loader size="sm" />
            </div>
        );
    }

    if (isSuccess && logs.length === 0) {
        return <NoRecords />;
    }

    return (
        <Tabs defaultValue="prompts">
            <Tabs.List>
                <Tabs.Tab leftSection={<FileText />} value="prompts">
                    Prompts
                </Tabs.Tab>
                <Tabs.Tab leftSection={<Terminal />} value="runtime">
                    Runtime
                </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="prompts">
                <Prompts logs={logs} />
            </Tabs.Panel>
            <Tabs.Panel value="runtime">
                <Runtime logs={logs} />
            </Tabs.Panel>
        </Tabs>
    );
};

export default MessageDetails;
